import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { MailIcon, MapPinIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { images, nav, site, socials } from '../data/site';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 border-b border-cocoa/10 bg-cream/95 backdrop-blur" data-id="element-16" data-mp="27t0sf357q5d">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-17" data-mp="h0czn3j9fbh0">
        <Link to="/" className="flex items-center gap-3" aria-label="LeonDesign — naar de homepage" data-id="element-18" data-mp="3knn26kazrpsq">
          <img src={images.logo} alt="Logo van LeonDesign met leeuwenkop" className="h-11 w-11 rounded-full border border-cocoa/10 object-cover" width={44} height={44} data-id="element-19" data-mp="3fojues3mn5h2" />
          <span className="leading-tight" data-id="element-20" data-mp="1msp985q4gegi">
            <span className="block font-display text-lg font-semibold tracking-tight text-ink" data-id="element-21" data-mp="1mre33z97eum8">
              LeonDesign
            </span>
            <span className="block text-xs font-medium uppercase tracking-wide text-pine" data-id="element-22" data-mp="1wjtlgxoexl7n">
              Lederwaren · Geleen
            </span>
          </span>
        </Link>

        <nav aria-label="Hoofdnavigatie" className="hidden lg:block" data-id="element-23" data-mp="13uwcjl63d0rk">
          <ul className="flex items-center gap-1" data-id="element-24" data-mp="13wz3c7f2ixxc">
            {nav.map(item => <li key={item.to} data-id="element-25" data-mp="18seir3sq51vv">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `rounded-full px-4 py-2 text-[15px] font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-sand text-ink' : 'text-cocoa/85 hover:bg-sand/60 hover:text-ink'}`} data-id="element-26" data-mp="1dt2icdv0qr1p">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-27" data-mp="29ij8ygt4zgah">
          <a href={site.phoneHref} className="inline-flex items-center gap-2 rounded-full bg-cocoa px-5 py-2.5 text-[15px] font-semibold text-cream transition-colors duration-150 ease-out hover:bg-ink" data-id="element-28" data-mp="24j6qe89asvdp">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" data-mp="1bvkbi3ume4bj" />
            {site.phone}
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-cocoa/20 text-cocoa lg:hidden" aria-expanded={open} aria-controls="mobiel-menu" aria-label={open ? 'Menu sluiten' : 'Menu openen'} data-id="element-30" data-mp="1qk6y8qmktycs">
          {open ? <XIcon className="h-5 w-5" data-id="element-31" data-mp="34qv15l80jdvm" /> : <MenuIcon className="h-5 w-5" data-id="element-32" data-mp="34qladvf592ov" />}
        </button>
      </div>

      {open && <div id="mobiel-menu" className="border-t border-cocoa/10 bg-cream lg:hidden" data-id="element-33" data-mp="39j4wjgrwd65a">
          <nav aria-label="Mobiele navigatie" className="mx-auto w-full max-w-6xl px-5 py-4 sm:px-8" data-id="element-34" data-mp="2utyqp9yk0hof">
            <ul className="space-y-1" data-id="element-35" data-mp="2zribksprbspc">
              {nav.map(item => <li key={item.to} data-id="element-36" data-mp="3ni4d0159aeqd">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block rounded-xl px-4 py-3 text-base font-medium ${isActive ? 'bg-sand text-ink' : 'text-cocoa hover:bg-sand/60'}`} data-id="element-37" data-mp="3nj5zd1rq2nne">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <a href={site.phoneHref} className="mt-3 flex items-center justify-center gap-2 rounded-full bg-cocoa px-5 py-3 text-base font-semibold text-cream" data-id="element-38" data-mp="274nu84o8l9g3">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="2ij91kjjte6qb" />
              Bel {site.phone}
            </a>
          </nav>
        </div>}
    </header>;
}
function Footer() {
  return <footer className="mt-24 border-t border-cocoa/10 bg-ink text-cream/85" data-id="element-40" data-mp="28mwcjyz7sh1w">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-4" data-id="element-41" data-mp="36a50e0mou272">
        <div className="md:col-span-2" data-id="element-42" data-mp="31a0koctltbhw">
          <img src={images.logo} alt="Logo van LeonDesign, specialist in lederwaren uit Geleen" className="h-14 w-14 rounded-full object-cover" width={56} height={56} data-id="element-43" data-mp="31b1u6cuz1pxi" />
          <p className="mt-5 max-w-sm text-[15px] leading-relaxed" data-id="element-44" data-mp="1kwae8zf0ib53">
            LeonDesign is een Nederlandse lederwarenwebshop uit Geleen, gespecialiseerd in leren
            portemonnees, horeca lederwaren en kleine leren accessoires voor particulieren en
            professionals.
          </p>
          <a href={site.website} target="_blank" rel="noopener noreferrer" className="mt-5 inline-block text-[15px] font-semibold text-sage underline decoration-sage/40 underline-offset-4 hover:text-cream" data-id="element-45" data-mp="e7y86zu8c1e">
            leondesign.nl
          </a>
        </div>

        <div data-id="element-46" data-mp="f3nntjnmubfi">
          <h2 className="font-display text-base font-semibold text-cream" data-id="element-47" data-mp="f22rbohrcif0">Pagina&apos;s</h2>
          <ul className="mt-4 space-y-2 text-[15px]" data-id="element-48" data-mp="k1fnizuir1u9">
            {nav.map(item => <li key={item.to} data-id="element-49" data-mp="o3akjs5f2t28">
                <Link to={item.to} className="hover:text-sage" data-id="element-50" data-mp="o4c0ob1ai5qt">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-51" data-mp="2pw8mqel32xzu">
          <h2 className="font-display text-base font-semibold text-cream" data-id="element-52" data-mp="2pwgwhxlwtn6t">Contact</h2>
          <address className="mt-4 space-y-3 text-[15px] not-italic" data-id="element-53" data-mp="2uvbe4w8555pc">
            <span className="flex gap-2" data-id="element-54" data-mp="1zi89zxa2l83">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-55" data-mp="20bkhgf0a2xm" />
              <span data-id="element-56" data-mp="3t7ea43f7415q">
                {site.street}
                <br data-id="element-57" data-mp="b0gdgljgcys9" />
                {site.postal} {site.city}
                <br data-id="element-58" data-mp="b1rjks0deimj" />
                {site.province}, {site.country}
              </span>
            </span>
            <span className="flex gap-2" data-id="element-59" data-mp="63hn8e2wtbzc">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-60" data-mp="ky49rfwpiecj" />
              <a href={site.phoneHref} className="hover:text-sage" data-id="element-61" data-mp="fzt4zjl9qu16">
                {site.phone}
              </a>
            </span>
            <span className="flex gap-2" data-id="element-62" data-mp="tpo5ru9yma3t">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-63" data-mp="tssg79e0q22x" />
              <a href={`mailto:${site.email}`} className="hover:text-sage" data-id="element-64" data-mp="prgx7mpngf3p">
                {site.email}
              </a>
            </span>
          </address>
          <ul className="mt-5 flex flex-wrap gap-x-4 gap-y-2 text-[15px]" data-id="element-65" data-mp="yrdhzd8x4tth">
            {socials.map(s => <li key={s.href} data-id="element-66" data-mp="1icdqjnln5dh1">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className="text-cream/80 hover:text-sage" data-id="element-67" data-mp="1i9zy7micifd6">
                  {s.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/10" data-id="element-68" data-mp="zkt83ef82lhc">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-5 py-6 text-sm text-cream/60 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-69" data-mp="zk1qj7igmoa2">
          <p data-id="element-70" data-mp="pnydh6m2l58c">
            KVK {site.kvk} · BTW {site.btw}
          </p>
          <p data-id="element-71" data-mp="um9p9mvxdpt7">Openingstijden webshop: {site.hours}</p>
        </div>
      </div>
    </footer>;
}
export function Layout() {
  return <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-72" data-mp="gnjonx9wd803">
      <ScrollToTop data-id="element-73" data-mp="knu6c771xmus" />
      <a href="#hoofdinhoud" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-cocoa focus:px-5 focus:py-3 focus:text-cream" data-id="element-74" data-mp="kobyarmoleww">
        Naar de hoofdinhoud
      </a>
      <Header data-id="element-75" data-mp="w2f908ropvyo" />
      <main id="hoofdinhoud" className="flex-1" data-id="element-76" data-mp="r5f5a4ib55aq">
        <Outlet data-id="element-77" data-mp="r43zy097rphi" />
      </main>
      <Footer data-id="element-78" data-mp="r7i33appc2q0" />
    </div>;
}